import type { AppRouteRecordRaw, AppRouteModule } from '/@/router/types'

import {
  PAGE_NOT_FOUND_ROUTE,
  REDIRECT_ROUTE,
  NOAUTH_ROUTE,
  MAINTENANCE_ROUTE,
  PERMISSION_EXCEPTION,
  dashboardNationalRoute,
  redirectDashboardRoute,
  biDashboardRoute,
  loginRoute,
} from '/@/router/routes/basic'

const modules = import.meta.glob('./modules/**/*.ts', { eager: true })

const routeModuleList: AppRouteModule[] = []

Object.keys(modules).forEach((key) => {
  const mod = modules[key].default || {}
  const modList = Array.isArray(mod) ? [...mod] : [mod]
  routeModuleList.push(...modList)
})

export const asyncRoutes = [PAGE_NOT_FOUND_ROUTE, ...routeModuleList]
export const RootRoute: AppRouteRecordRaw = {
  path: '/',
  name: 'Root',
  redirect: `/zh_CN/dashboard`,
  meta: {
    title: 'Root',
  },
}

// Basic routing without permission
export const basicRoutes = [
  REDIRECT_ROUTE,
  NOAUTH_ROUTE,
  MAINTENANCE_ROUTE,
  PERMISSION_EXCEPTION,
  dashboardNationalRoute,
  biDashboardRoute,
  RootRoute,
  redirectDashboardRoute,
  loginRoute,
]
